var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOptionsIcon = function SvgOptionsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33335 8.3335C4.25383 8.3335 5.00002 9.07969 5.00002 10.0002C5.00002 10.9206 4.25383 11.6668 3.33335 11.6668C2.41288 11.6668 1.66669 10.9206 1.66669 10.0002C1.66669 9.07969 2.41288 8.3335 3.33335 8.3335ZM16.6667 8.3335C17.5872 8.3335 18.3334 9.07969 18.3334 10.0002C18.3334 10.9206 17.5872 11.6668 16.6667 11.6668C15.7462 11.6668 15 10.9206 15 10.0002C15 9.07969 15.7462 8.3335 16.6667 8.3335ZM10 8.3335C10.9205 8.3335 11.6667 9.07969 11.6667 10.0002C11.6667 10.9206 10.9205 11.6668 10 11.6668C9.07955 11.6668 8.33335 10.9206 8.33335 10.0002C8.33335 9.07969 9.07955 8.3335 10 8.3335Z",
    fill: "#767676"
  })));
};
export { SvgOptionsIcon as ReactComponent };
export default __webpack_public_path__ + "assets/91da6578.svg";